import { Badge, useMantineTheme, useComputedColorScheme } from '@mantine/core';
import { useMemo } from 'react';

interface StatusBadgeProps {
  children: any;
  active?: boolean;
}

export const StatusBadge: React.FC<StatusBadgeProps> = ({
  children,
  active = true,
}) => {
  const theme = useMantineTheme();
  const computedColorScheme = useComputedColorScheme('dark');

  const color = useMemo(() => {
    return active
      ? theme.colors[`accent-${computedColorScheme}`][0]
      : theme.colors[`gray-${computedColorScheme}`][0];
  }, [active, theme.colors, computedColorScheme]);

  const style = useMemo(
    () => ({
      color: computedColorScheme === 'dark' ? theme.colors.dark[9] : 'white',
    }),
    [computedColorScheme, theme.colors.dark]
  );

  return (
    <Badge radius="sm" color={color} style={style}>
      {children}
    </Badge>
  );
};
